import React from "react";
import formatearFecha from "../utils/formateo";
const List = ({ data }) => {

  return (
    <>
      {data.map((res) => (
        <div key={res.id} className="card">
        <div className="container-img-card">
          <img  className="grid__img" src={res.image} alt="" />
        </div>
          <div className="card_p">
            <p >Nombre: {res.name}</p>
            <p>Estado: {res.status}</p>
            <p>Especie: {res.species}</p>
            <p>Ubicacion: {res.location.name}</p>
            <p>Creado: {formatearFecha(res.created)}</p>
          </div>
        </div>
      ))}
    </>
  );
};

export default List;
